module.exports = __webpack_public_path__ + "img/icon03.5e837680.png";